<template>
  <div :class="[ 'collection', model ]">
    <table class="table" v-if="loading == false">
      <thead>
        <tr>
          <th class="heading" :class="column.class" v-for="column in structure" :key="column.name" v-can-dom="column.credentials">
            <span :title="$t('models.' + model + '.' + column.name)" class="heading--title icon" v-if="column.icon">
              {{column.icon}}
            </span>
            <span class="heading--title" v-else-if="column.alias">
              {{$t("models." + model + "." + column.alias)}}
            </span>
            <span class="heading--title" v-else-if="(column.name == 'classification')">
              <!-- we don't want to show "classification" in the heading title -->
            </span>
            <span class="heading--title" v-else>
              {{$t("models." + model + "." + column.name)}}
            </span>
            <div :class="{ 'heading--sorting' : true, 'is-active': sortKey == column.name }" v-if="column.sortable && sortedData.length > 0">
              <a class="icon yule-icon-chevron-down icon-tiny" @click="sortBy(column.name)" v-if="reverse && sortKey == column.name"></a>
              <a class="icon yule-icon-chevron-top icon-tiny" @click="sortBy(column.name)" v-if="!reverse && sortKey == column.name"></a>
              <a class="icon yule-icon-chevron-right icon-tiny" @click="sortBy(column.name)" v-if="sortKey != column.name"></a>
            </div>
          </th>
        </tr>
      </thead>
      <tbody v-if="collectionPresent()">
        <tr v-for="item in sortedData" :key="item.id" class="collection--row">
          <collection-value @itemDelete="itemDelete" :params="params" v-for="column in structure" v-bind="{toString: () => item.id}" v-can-dom="column.credentials" :model="model" :column="column" :item="item" :key="column.name"></collection-value>
        </tr>
      </tbody>
      <div v-else-if="loadingCollection()">
        <loading></loading>
      </div>
      <tbody v-else-if="noResultsHandler()">
        <tr class="txtcenter">
          <td :colspan="structure.length">{{$t('ui.global.no_results')}}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="txtcenter">
          <td :colspan="structure.length">{{$t('ui.global.empty_collection')}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import CollectionValue from './CollectionValue'
import Loading from '@/components/helpers/Specific/Loading.vue'

export default {
  name: 'collection',
  components: {
    CollectionValue,
    Loading
  },
  data(){
    return {
      sortKey: '',
      reverse: true
    }
  },
  props: {
    structure: {},
    data: {},
    params: {},
    model: String,
    loading: Boolean,
    has_searched: Boolean
  },
  computed: {
    sortedData(){
      if(_.get(this,'params.global_sorting') == true){
        return this.data
      }
      if(this.sortKey == ''){
        return this.data
      }else{
        return this.data ? this.data.sort(this.dynamicSort(this.sortKey)) : []
      }
    }
  },
  mounted(){
    this.initOrder()
  },
  watch: {
    params:{
      deep:true,
      handler(){
        this.initOrder()
      }
    }
  },
  methods: {
    searchBarPresent() {
      this.$route.name !== "projects" && this.$route.name !== "project_leads"
    },
    collectionPresent(){
      return this.sortedData && this.sortedData.length > 0
    },
    noResultsHandler() {
      return this.has_searched && this.sortedData.length == 0
    },
    loadingCollection() {
      if (this.searchBarPresent()) {
        return !this.has_searched && this.data.length == 0
      }
    },
    initOrder(){
      if(_.get(this,'params.sort_by')){
        this.sortKey = this.params.sort_by
      }
      if(_.get(this,'params.sort_order')){
        this.reverse = (this.params.sort_order == 'DESC')
      }
    },
    sortBy(sortKey){
      this.reverse = (this.sortKey == sortKey) ? !this.reverse : false
      this.sortKey = sortKey
      if(_.get(this,'params.global_sorting') == true){
        let sort_order = (this.reverse) ? 'DESC' : 'ASC'
        this.$emit('sorting', {sort_by: sortKey, sort_order})
      }
    },
    dynamicSort(property) {
      let sortOrder = this.reverse ? -1 : 1;
      return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    },
    itemDelete(item){
      this.$emit('itemDelete',item)
    },
    classes(column){
      return ['value', this.model + '-' + column.name]
    },
    textToShow(item,column){
      let output

      if(this.column.type != 'edit'){
        try {
          output = eval('item.' + this.column.name);
        } catch (e) {
          if (e instanceof SyntaxError) {
            console.log(e.message);
          }
        }
      }
      return output
    }
  }
}
</script>
<style lang="scss">
.collection{
  margin-bottom: 1em;
  overflow: auto;
  padding-bottom: 4.5em;
  .table{
    width: 99%;
  }
  .value{
    vertical-align: middle;
  }
  .is-display-none{
    display: none;
  }
}
.collection .heading{
  position: relative;
  font-weight: $font-medium;
  white-space: nowrap;
  color: $paper-dark;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: .8em;
  .icon {
    font-size: 11px;
    vertical-align: -webkit-baseline-middle;
  }
  &.txtcenter{
    text-align: center;
  }
  .heading--title{
    vertical-align: middle;
    line-height: 24px;
    &.icon{
      display: inline-block;
      margin: 0 auto;
    }
  }
}

.collection--row:hover {
  transition: all .15s ease-out;
  background-color: $paper-lighter;
}
.collection .heading--sorting{
  display: inline-block;
  margin-left: 0.2em;
  vertical-align: middle;
  height: 24px;
  &.is-active{
    color: $sensual !important;
  }
  user-select: none;
  .icon{
    font-size: 16px;
    cursor: pointer;
    color: $ink-lighter;
    transition: all .15s ease-out;
    &:hover{
      color: $ink-dark;
    }
  }
  .is-rotated{
    transform: rotate(90deg);
  }
}
.heading.no-padding{
  padding: 0;
  text-align:center;
}
.main-content .collection .spinner-wrapper{
  display: block;
}
</style>



// WEBPACK FOOTER //
// Collection.vue?974066aa